import "./TeeListClubLanding.module.css";
import Header from "@/reusable_sections/Header";
import GolfResortPartnerHero from "./sections/GolfResortPartnerHero";
import CoursePartnershipComparison from "./sections/CoursePartnershipComparison";
import PartnerBenefitsGrid from "./sections/PartnerBenefitsGrid";
import PartnerCoursePresentation from "./sections/PartnerCoursePresentation";
import BusinessPrioritiesGrid from "./sections/BusinessPrioritiesGrid";
import ReassuranceBand from "./sections/ReassuranceBand";
import PartnerEnquiry from "./sections/PartnerEnquiry";
import Footer from "@/reusable_sections/Footer";
export default function TeeListClubLandingPage() {
  return <div className="min-h-screen bg-[#f7f3ea] text-[#082417]">
      <Header />
      <GolfResortPartnerHero />
      <CoursePartnershipComparison />
      <PartnerBenefitsGrid />
      <PartnerCoursePresentation />
      <BusinessPrioritiesGrid />
      <ReassuranceBand />
      <PartnerEnquiry />
      <Footer />
    </div>;
}